export default "__VITE_ASSET__Bwwqly7Q__"